import React, { useState } from "react";
import { Grid, TextField, } from "@mui/material";
import { parseISO } from "date-fns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { NumericFormat } from "react-number-format";

function QuotationHeader({ fields, data, handleInputChange }) {
  const [localValue, setLocalValue] = useState("");

  const handleLocalChange = (field, value) => {
    setLocalValue((prev) => ({...prev, [field]: value}));
    handleInputChange(field, value);
  };

  return (
    <MDBox p={3}>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBR}>
        <Grid container spacing={2}>
          {fields.map((field) => (
            <Grid item xs={12} sm={12} md={12} lg={3} key={field.name}>
              <MDBox mb={1} fullWidth>
                <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase" fullWidth>
                  {field.label}
                </MDTypography>
                {field.type === "date" ? (
                  <MDBox>
                    <DatePicker
                      format="dd/MM/yyyy"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 37,
                        },
                        "&.MuiFormControl-root": {
                          width: "100%",
                        },
                        mt: 0.5,
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: field.editable ? "inherit" : "#f0f0f0",
                          "& fieldset": { borderColor: "rgba(0, 0, 0, 0.12)" },
                        },
                      }}
                      value={parseISO(data[field.name])}
                      onChange={(newValue) => {
                        if (field.editable) {
                          handleInputChange(field.name, newValue ? newValue.toISOString().split('T')[0] : null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            readOnly: !field.editable,
                          }}
                        />
                      )}
                      readOnly={!field.editable}
                    />
                  </MDBox>
                  ) : field.type === "select" ? (
                      <select
                        name={field.name}
                        value={data[field.name]}
                        disabled={!field.editable}
                        onChange={(e) => handleInputChange(field.name, e.target.value)}
                        style={{ 
                          fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"', 
                          fontSize: "0.75rem",
                          fontWeight: "400",
                          lineHeight: "1.4375em",
                          letterSpacing: "0.00938em",
                          borderColor: 'rgb(197 197 197)',
                          boxSizing: "border-box",
                          display: "inline-flex",
                          alignItems: "center",
                          width: "100%",
                          position: "relative",
                          borderRadius: "4px",
                          backgroundColor: "transparent",
                          borderRadius: "0.375rem",
                          height: "35px",
                          color: "#495057",
                          padding: "0.5rem",
                        }}
                      >
                        {field.options.map((option, index) => (
                          <option key={index} value={option.Id}>
                            {option.Description}
                          </option>
                        ))}
                      </select>
                    ) : field.type === "currency" ? (
                      <NumericFormat
                            customInput={TextField}
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={data[field.name] || ""}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative={false}
                            prefix="R$ "
                            onValueChange={(values) => {
                              if (field.editable) {
                                handleInputChange(
                                  field.name,
                                  values.value
                                );
                              }
                            }}
                            inputProps= {{ readOnly: !field.editable }}
                            sx= {{
                              backgroundColor: field.editable ? "inherit" : "#f0f0f0",
                              color: "black",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "rgba(0, 0, 0, 0.12)" },
                              },
                            }}
                          />
                    ) : (
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type={field.type}
                    onChange={(e) => handleLocalChange(field.name, e.target.value)}
                    InputProps={{ readOnly: !field.editable }}
                    name={field.name}
                    value={(field.options ? field.options.find((option) => option.Id === data[field.name]).Description : localValue[field.name] || data[field.name])}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: field.editable ? "inherit" : "#f0f0f0",
                        "& fieldset": { borderColor: "rgba(0, 0, 0, 0.12)" },
                      },
                    }}
                  />
                )}
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </LocalizationProvider>
    </MDBox>
  );
}

export default QuotationHeader;